function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState, useRef } from 'react';
import { Box, Typography, IconButton, Paper } from '@mui/material';
import DeleteIcon from '../../public/DeleteIcon.svg';
import FileIcon from '../../public/FileIcon.svg';
import FileIconUpload from '../../public/FileIconUpload.svg';
import ErrorIcon from '../../public/Error.svg';
import { constants } from '../constants';
import { theme } from '@/styles/theme';
import { ConfigContext } from './ConfigContext';
var FilePicker = function FilePicker(_ref) {
    var _configState$settings;
    var onFilesChange = _ref.onFilesChange, _ref$maxTotalSize = _ref.maxTotalSize, maxTotalSize = _ref$maxTotalSize === void 0 ? 10 * 1024 * 1024 : _ref$maxTotalSize, _ref$acceptedTypes = _ref.acceptedTypes, acceptedTypes = _ref$acceptedTypes === void 0 ? ['.png', '.jpg', '.jpeg', '.txt'] : _ref$acceptedTypes, _ref$multiple = _ref.multiple, multiple = _ref$multiple === void 0 ? true : _ref$multiple;
    var _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), selectedFiles = _useState2[0], setSelectedFiles = _useState2[1];
    var _useState3 = useState(''), _useState4 = _slicedToArray(_useState3, 2), error = _useState4[0], setError = _useState4[1];
    var fileInputRef = useRef(null);
    var _React$useContext = React.useContext(ConfigContext), configState = _React$useContext.configState;
    var formatFileSize = function formatFileSize(bytes) {
        if (bytes === 0)
            return '0B';
        var k = 1024;
        var sizes = ['B', 'KB', 'MB', 'GB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return Number.parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + sizes[i];
    };
    var formatAcceptedTypes = function formatAcceptedTypes(types) {
        var cleanTypes = types.map(function (type) {
            return type.startsWith('.') ? type.slice(1).toUpperCase() : type.toUpperCase();
        });
        if (cleanTypes.length === 1) {
            return cleanTypes[0];
        }
        if (cleanTypes.length === 2) {
            return cleanTypes.join(', ');
        }
        var lastType = cleanTypes.pop();
        return cleanTypes.join(', ') + ', ' + constants.or + ' ' + lastType;
    };
    var validateFiles = function validateFiles(newFiles) {
        var isRemoved = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var errors = [];
        var valid = [];
        var _iterator = _createForOfIteratorHelper(newFiles), _step;
        try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _file$name$split$pop;
                var file = _step.value;
                // Check file type
                var fileExtension = '.' + ((_file$name$split$pop = file.name.split('.').pop()) === null || _file$name$split$pop === void 0 ? void 0 : _file$name$split$pop.toLowerCase());
                if (!acceptedTypes.includes(fileExtension)) {
                    errors.push(constants.file_picker_error_invalid_type(file.name, acceptedTypes.join(', ')));
                    continue;
                }
                valid.push(file);
            }
        }
        catch (err) {
            _iterator.e(err);
        }
        finally {
            _iterator.f();
        }
        var currentFiles = selectedFiles.map(function (sf) {
            return sf.file;
        });
        var allFiles = isRemoved ? valid : [].concat(_toConsumableArray(currentFiles), valid);
        var totalSize = allFiles.reduce(function (sum, file) {
            return sum + file.size;
        }, 0);
        if (totalSize > maxTotalSize) {
            var _maxSizeFormatted = formatFileSize(maxTotalSize);
            errors.push(constants.file_picker_error_max_size(_maxSizeFormatted));
            return {
                valid: [],
                errors: errors
            };
        }
        return {
            valid: valid,
            errors: errors
        };
    };
    var handleFiles = function handleFiles(files) {
        if (!files)
            return;
        var fileArray = Array.from(files);
        var _validateFiles = validateFiles(fileArray), errors = _validateFiles.errors;
        if (errors.length > 0) {
            setError(errors.join('. '));
        }
        else {
            setError('');
        }
        var newSelectedFiles = fileArray.map(function (file, index) {
            return {
                file: file,
                id: "".concat(file.name, "-").concat(Date.now(), "-").concat(index)
            };
        });
        var updatedFiles = multiple ? [].concat(_toConsumableArray(selectedFiles), _toConsumableArray(newSelectedFiles)) : newSelectedFiles;
        setSelectedFiles(updatedFiles);
        onFilesChange === null || onFilesChange === void 0 || onFilesChange(updatedFiles.map(function (sf) {
            return sf.file;
        }), errors.length <= 0);
    };
    var handleDrop = function handleDrop(e) {
        e.preventDefault();
        handleFiles(e.dataTransfer.files);
    };
    var handleDragOver = function handleDragOver(e) {
        e.preventDefault();
    };
    var handleDragLeave = function handleDragLeave(e) {
        e.preventDefault();
    };
    var handleClick = function handleClick() {
        var _fileInputRef$current;
        (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 || _fileInputRef$current.click();
    };
    var handleFileInputChange = function handleFileInputChange(e) {
        handleFiles(e.target.files);
    };
    var removeFile = function removeFile(id) {
        var updatedFiles = selectedFiles.filter(function (sf) {
            return sf.id !== id;
        });
        setSelectedFiles(updatedFiles);
        var _validateFiles2 = validateFiles(updatedFiles.map(function (sf) {
            return sf.file;
        }), true), errors = _validateFiles2.errors;
        if (errors.length > 0) {
            setError(errors.join('. '));
        }
        else {
            setError('');
        }
        onFilesChange === null || onFilesChange === void 0 || onFilesChange(updatedFiles.map(function (sf) {
            return sf.file;
        }), errors.length <= 0);
    };
    var maxSizeFormatted = formatFileSize(maxTotalSize);
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            width: '100%',
            maxWidth: 800,
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
        }
    }, /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Paper, {
        elevation: 0,
        onClick: handleClick,
        onDrop: handleDrop,
        onDragOver: handleDragOver,
        onDragLeave: handleDragLeave,
        sx: {
            border: error.length > 0 ? "1px dashed ".concat(theme.custom.errorColor) : '1px dashed #d9d9d9',
            borderRadius: 2,
            p: 2,
            textAlign: 'center',
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#F8F8F8',
            color: error.length > 0 ? '#9E9E9E' : 'inherit'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            width: '40px',
            height: '40px',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '100px',
            opacity: 0.6,
            backgroundColor: '#EBEBEB',
            marginRight: '8px'
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: FileIconUpload,
        alt: "upload icon"
    })), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            display: 'flex'
        }
    }, constants.drag_drop_upload, "\xA0", /*#__PURE__*/ React.createElement(Box, {
        sx: {
            color: error.length > 0 ? '#9E9E9E' : configState === null || configState === void 0 || (_configState$settings = configState.settings) === null || _configState$settings === void 0 ? void 0 : _configState$settings.button_color,
            fontWeight: 600,
            textDecorationLine: 'underline',
            textDecorationStyle: 'solid'
        }
    }, constants.browse_file)), /*#__PURE__*/ React.createElement(Typography, {
        color: error.length > 0 ? '#9E9E9E' : 'textSecondary',
        fontSize: "14px",
        ml: 'auto'
    }, constants.file_picker_supported_types_line(formatAcceptedTypes(acceptedTypes), maxSizeFormatted))), /*#__PURE__*/ React.createElement("input", {
        ref: fileInputRef,
        type: "file",
        multiple: multiple,
        accept: acceptedTypes.join(','),
        onChange: handleFileInputChange,
        style: {
            display: 'none'
        },
        disabled: error.length > 0
    }), error && /*#__PURE__*/ React.createElement(Typography, {
        color: "error",
        variant: "caption",
        mt: '4px',
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
        },
        "aria-label": "error-text"
    }, /*#__PURE__*/ React.createElement("img", {
        src: ErrorIcon,
        alt: "error icon"
    }), error)), selectedFiles.length > 0 && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
        }
    }, selectedFiles.map(function (selectedFile) {
        return /*#__PURE__*/ React.createElement(Box, {
            key: selectedFile.id,
            sx: {
                display: 'flex',
                padding: '12px',
                alignItems: 'center',
                gap: '8px',
                borderRadius: '8px',
                border: '1px solid #D9D9D9',
                background: '#FFF'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                width: '24px',
                height: '24px',
                flexShrink: 0,
                position: 'relative'
            }
        }, /*#__PURE__*/ React.createElement("img", {
            src: FileIcon,
            alt: "file icon"
        })), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                flex: 1
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '8px',
                justifyContent: 'space-between'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "body2"
        }, selectedFile.file.name), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
            }
        }, /*#__PURE__*/ React.createElement(IconButton, {
            size: "small",
            "aria-label": "delete",
            onClick: function onClick() {
                return removeFile(selectedFile.id);
            },
            sx: {
                width: '24px',
                height: '24px',
                padding: 0,
                '&:hover': {
                    backgroundColor: 'rgba(218, 41, 28, 0.04)'
                }
            }
        }, /*#__PURE__*/ React.createElement("img", {
            src: DeleteIcon,
            alt: "delete icon"
        })))), /*#__PURE__*/ React.createElement(Typography, {
            variant: "caption",
            sx: {
                fontSize: '12px'
            }
        }, formatFileSize(selectedFile.file.size))));
    })));
};
export default FilePicker;
